var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Container, Title, Subtitle, Button, Link, Illustration, } from './elements';
import data, { assetsUrl } from './data';
import { errorCodes, } from './types';
export var ErrorPage = forwardRef(function (_a, fRef) {
    var code = _a.code, _b = _a.title, title = _b === void 0 ? "Something's not right" : _b, _c = _a.subtitle, subtitle = _c === void 0 ? "That's entirely our fault.\nPlease try again soon and everything should be back to normal." : _c, _d = _a.actionLabel, actionLabel = _d === void 0 ? 'Go to homepage' : _d, _e = _a.button, button = _e === void 0 ? {} : _e, _f = _a.link, link = _f === void 0 ? {} : _f, _g = _a.illustration, illustration = _g === void 0 ? (React.createElement(Illustration, { src: "".concat(assetsUrl, "/images/astro.png"), role: "presentation" })) : _g, rest = __rest(_a, ["code", "title", "subtitle", "actionLabel", "button", "link", "illustration"]);
    var props = { title: title, subtitle: subtitle, actionLabel: actionLabel, illustration: illustration };
    if (code && errorCodes.includes(code)) {
        props = data[code];
    }
    return (React.createElement(Container, __assign({ ref: fRef }, rest),
        React.createElement(Title, null, props.title),
        React.createElement(Subtitle, null, props.subtitle),
        props.illustration,
        link.href ? (React.createElement(Link, __assign({ variant: "button", href: link.href }, link), props.actionLabel)) : (React.createElement(Button, __assign({}, button), actionLabel))));
});
